import api from '../../../utils/api'
import types from '../mutations/mutation-types'

export default {
  async getAllMenus ({ commit }) {
    try {
      const { status, data } = await api.buildRequest('menu', 'get', null)
      if (status === 200) {
        commit(types.MENU.GET_ALL_MENUS, data.payload.menu)
      }
    } catch (error) {
      throw error
    }
  },
  async getAllOptions ({ commit }) {
    try {
      const { status, data } = await api.buildRequest('app?deployed=1', 'get', null)
      if (status === 200) {
        let { apps } = data.payload
        apps = apps.map(each => ({
          value: `GENERIC_SMS_APP###${each.name}`,
          label: each.name
        }))
        apps.push({
          value: 'GENERIC_APP_REFERRAL',
          label: 'SCREENING REFERRAL'
        })
        commit(types.MENU.SET_APPS, apps)
      }
    } catch (error) {
      throw error
    }
  },
  /**
   * @description adds an option to menu options
   * @param {object}
   * @typedef {Object}
   * @property {string} eng The english translation
   * @property {string} swa The swahili translation
   * @property {string} nextStage The next stage menu name (if any)
   * @property {string[]} nextApps Array of next apps that should run
   */
  addMenuOption ({ commit }, option) {
    commit(types.MENU.ADD_MENU_OPTION, option)
  },

  /**
   * @description remove a menu option from all options list
   * @param {object}
   * @param {number} index
   */
  removeOption ({ commit }, index) {
    commit(types.MENU.REMOVE_MENU_OPTION, index)
  },
  saveMenuAction ({ commit, state }, details) {
    return new Promise(async (resolve, reject) => {
      try {
        let status, data
        if (state.aMenu._id) {
          // update the menu
          ({ status, data } = await api.buildRequest(`menu/${state.aMenu._id}`, 'put', details))
          commit(types.MENU.EDIT_MENU, {
            details: data.payload.data,
            id: state.aMenu._id
          })
        } else {
          // create a new one
          ({ status, data } = await api.buildRequest('menu', 'post', details))
          commit(types.MENU.ADD_MENU, data.payload.data)
        }
        if (status === 201 || status === 200) {
          return resolve({ status, message: data.payload.message })
        }
        reject(data.payload.message)
      } catch (error) {
        reject('An error occurred')
      }
    })
  },
  updateMenuAction ({ commit }, details) {
    commit(types.MENU.UPDATE_MENU_FIELD, details)
  },
  editMenu ({ commit, state }, index) {
    const theMenu = state.menus[index]
    const options = theMenu.options
    const details = { ...theMenu, options: null }
    commit(types.MENU.SET_A_MENU, { details, options })
  },
  cancelAction ({ commit }) {
    commit(types.MENU.SET_A_MENU, {
      details: {
        name: '',
        gender: '',
        message: '',
        swahili: ''
      },
      options: []
    })
  },
  editMenuOptionAction ({ commit }, option) {
    const { index } = option
    delete option.index
    commit(types.MENU.EDIT_MENU_OPTION, {
      option,
      index
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/menu.js